<template>
  <!-- 权限配置 -->
  <div>
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-input
          v-model="query.account"
          placeholder="请输入用户账号"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="handleQuery"
          >查询</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          :loading="btnLoading"
          @click="handleSave"
          >保存权限</el-button
        >
      </el-form-item>
    </el-form>
    <div class="buttons">
      <el-button type="primary" @click="resetChecked">清空</el-button>
      <el-button type="primary" @click="getPermissionsTree">全选</el-button>
    </div>
    <br />
    <el-tree
      :data="permissionTree"
      show-checkbox
      default-expand-all
      node-key="id"
      :default-checked-keys="selectArr"
      ref="tree"
      highlight-current
      :props="defaultProps"
    >
    </el-tree>
  </div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
import routerTree from '@/router/routerTree'
import http, { server, getData, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import { Message } from 'element-ui'

export default {
  data() {
    return {
      loading: false,//页面加载
      btnLoading: false,//按钮加载
      query: {
        account: '',//用户账号
      },
      permissionTree: routerTree,//权限树
      selectArr: ['-1'],//选中的权限
      statisticalArr: ['-1'],//统计权限数组
      defaultProps: {//权限页面指定字段
        children: 'children',
        label: 'title',
      },
    }
  },
  methods: {
    ...mapMutations(['setUserPermissions']),
    //查询用户权限
    handleQuery() {
      let params = this.query
      getApiData(`get_per`, params)
        .then(res => {
          this.$refs.tree.setCheckedKeys(res.power);
        })
        .finally(() => {
        })
    },
    //保存用户权限
    handleSave() {
      if (!this.query.account) {
        this.$message.warning("请先输入用户账号")
        return
      }
      this.$confirm('确定要保存权限吗？', {
        type: 'warning'
      }).then(res => {
        this.btnLoading = true
        let params = {
          account: this.query.account,
          power: this.$refs.tree.getCheckedKeys()
        }
        postApiData('set_per', params)
          .then(res => {
            this.$message.success("操作成功！")
          })
          .finally(() => {
            this.btnLoading = false
          })
      })
    },
    //清空
    resetChecked() {
      this.$refs.tree.setCheckedKeys(['-1']);
    },
    //全选权限
    getPermissionsTree() {
      this.statisticalArr = []
      this.selectAll(this.permissionTree)
      this.selectArr = this.statisticalArr
    },
    //遍历权限树获取id列表
    selectAll(list) {
      list.forEach(element => {
        if (!this.statisticalArr.includes(element.id)) {
          this.statisticalArr.push(element.id)
        }
        if (element.children) {
          this.selectAll(element.children)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>